// @ts-nocheck
import React from "react";
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Zoom from '@mui/material/Zoom';
import Tooltip from '@mui/material/Tooltip';
import { Cruz, Download } from "../../../../Componentes/Icons";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapTheme from "../../../../styles/SinapTheme";



const icons = {
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" : <img width="25px" height="25px" src="https://img.icons8.com/ios-filled/70/000000/ms-word.png"/>,
    "docx" : <img width="25px" height="25px" src="https://img.icons8.com/ios-filled/70/000000/ms-word.png"/>,
    "application/vnd.openxmlformats-officedocument.presentationml.presentation" : <img  width="25px" height="25px" src="https://img.icons8.com/ios-filled/50/000000/ms-powerpoint.png"/>,
    "pptx" : <img width="25px" height="25px" src="https://img.icons8.com/ios-filled/50/000000/ms-powerpoint.png"/>,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : <img  width="25px" height="25px" src="https://img.icons8.com/ios-filled/70/000000/ms-excel.png"/>,
    "xlsx" : <img width="25px" height="25px" src="https://img.icons8.com/ios-filled/70/000000/ms-excel.png"/>,
    "text/plain" : <TextSnippetIcon sx={{ fontSize: '200%' }}/>,
    "txt" : <TextSnippetIcon sx={{ fontSize: '200%' }}/>,
    "application/zip" : <FolderZipIcon sx={{ fontSize: '200%' }}/>,
    "zip" :  <FolderZipIcon sx={{ fontSize: '200%' }}/>,
    "application/pdf" : <PictureAsPdfIcon sx={{ fontSize: '200%' }}/>,
    "pdf" : <PictureAsPdfIcon sx={{ fontSize: '200%' }}/>,
    "png" : <ImageIcon sx={{ fontSize: '200%' }}/>,
    "jpg" : <ImageIcon sx={{ fontSize: '200%' }}/>,
    "jpeg" : <ImageIcon sx={{ fontSize: '200%' }}/>,
    "image/png" : <ImageIcon sx={{ fontSize: '200%' }}/>,
    "image/jpg" : <ImageIcon sx={{ fontSize: '200%' }}/>,
    "image/jpeg" : <ImageIcon sx={{ fontSize: '200%' }}/>
}



export default function FileCard(props) {

    const {nombreDelArchivo , onClick , type  , descargar} = props;

    const seleccionarIcono = () => {
            return(
                <>
                 {icons[type]}
                </>
            );

    };



    return (
        <Zoom in={true}>
                        <ListItem
                            key={nombreDelArchivo}
                            secondaryAction={ onClick ?
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={SinapTheme}>
                                        <Tooltip title="Eliminar">
                                            <span><Cruz onClick={onClick} /></span>
                                        </Tooltip>
                                    </ThemeProvider>
                                </StyledEngineProvider> :
                                descargar ?
                                <Tooltip title="Descargar">
                                    <span><Download onClick={descargar} /></span>
                                </Tooltip> :
                                ""
                            }
                        >
                            <ListItemAvatar>
                                {seleccionarIcono()}
                            </ListItemAvatar>
                            <ListItemText
                                primary={nombreDelArchivo}
                            />
                        </ListItem>
                    </Zoom>
    );
}
